import React from 'react'
import ContactInfo from '../Components/ContactInfo/ContactInfo'

export default function ContactUs() {
  return (
    <div>
        <ContactInfo/>
    </div>
  )
}
